<!--

===========================================================================================================================
||    StepperJsonSchemaBlank component                                                                                   ||
===========================================================================================================================

|   Description
------------------------------------------------------------------------------------------------------------
  Stepper needs a component for every step and this component is used as a wrapper for json schema provided for the step.

|   Features
------------------------------------------------------------------------------------------------------------
  - Title for the step
  - Description for the step

|   Props - props are passed via schema componentsConfig which should be changed durring rewrite and standardised
------------------------------------------------------------------------------------------------------------
  - title             : String    : Title for the step.
  - description       : String    : Description for the step.
  - jsonSchema        : Object    : Json schema for the step.

|   Events
------------------------------------------------------------------------------------------------------------
  - input       : Object    : Emits object with valid, name and data values. Data value contains everything user has filled in the form based on the schema received.

|   v-model
------------------------------------------------------------------------------------------------------------
  {
    valid: [Boolean],
    name: [String],
    data: [Object],
  }

|   TODO
------------------------------------------------------------------------------------------------------------
  - reset should be implemented in individual components and form in general for easier reseting the form to initial data.

-->

<template>
  <div
    :id="`assistant-step-${dat.index}`"
    class="assistant-forms">
    <h2 v-if="dat && dat.title" class="title">{{ dat.title }}</h2>
    <p v-if="dat && dat.subtitle" class="subtitle">{{ dat.subtitle }}</p>
    <!-- Dummy input is used for refocusing elements on step change or form schema change. -->
    <input
      :id="`dummyInput-${dat.index}`"
      type="hidden" >

    <JsonSchema
      v-if="showIt"
      ref="jsonSchema"
      v-model="formValue"
      :schema="schema | processSchema(stepID)"
      :components="componentsConfig"
      :ui-schema="uiSchema"
      :wrapper="wrapperComponentConfig"
      @init-default="initDefault"
      @input="() => {}" />

    <!-- <div> dataModel </div> -->
    <!-- <pre class="debug"> {{ value }} </pre> -->
  </div>
</template>

<script>
import JsonSchema from '@roma219/vue-jsonschema-form';

import randomString from '@/helpers/randomString';
import ToasterMixin from '../../mixins/Toaster';
import FormSchemaMixin from '../forms_schema/FormSchema.mixin';

export default {
  name: 'StepperFormSchemaBlank',
  components: {
    JsonSchema,
  },
  mixins: [
    ToasterMixin,
    FormSchemaMixin,
  ],
  props: {
    dat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showIt: false,
      initialized: false,
      // steps: 4,
      // currentStep: 1,
      // initializedSteps: [],
      formValue: {},
      debouncer: null,
      focusDebouncer: null,
      preventBlur: false,
      stepID: randomString(),
    };
  },
  computed: {
    schemaBP() {
      return this.dat.jsonSchema;
    },
  },
  watch: {
    formValue: {
      handler(oldd, newd) {
        window.eventBus.$emit('mark-scroll');
        this.runCustomValidators(this.formValue);
        this.$nextTick(() => {
          this.checkData();
          // Refocusing when the form schema changes
          if (this.initialized && Object.keys(oldd).toString() !== Object.keys(newd).toString()) {
            clearTimeout(this.focusDebouncer);
            this.focusDebouncer = setTimeout(() => {
              // this.$emit('scrollToTop');
              // this.focusDummy();
              // this.focusFirstInput();
              this.blurInputs();
              window.eventBus.$emit('reset-scroll');
            }, 500);
          }
        });
      },
      deep: true,
      immediate: false,
    },
  },
  updated() {
    this.stepUpdate();
  },
  mounted() {
    // window.eventBus.$on('assistantStepsInit', this.stepInit);

    // setTimeout(() => {
    // console.log('SHOW IT');
    this.showIt = true;
    // }, 0);
  },
  methods: {
    /** Removes blur from all the contenteditable tags. */
    blurInputs() {
      if (this.preventBlur) return;
      const inputs = document.querySelectorAll('[contentEditable]');
      inputs.forEach((input) => {
        input.blur();
      });
      window.getSelection().removeAllRanges();
    },
    allowJump() {
      // TODO - check if the form is valid and there are changes - use dirty from each form input
      return true;
    },
    focus() {
      // console.log('FOCUS', this.dat.index);
      this.focusFirstInput();
    },
    // stepInit(data) {
    //   console.log('aaaaaaa Step initialized', this.dat.index, data.step);
    //   this.initializedSteps.push(data.step);
    //   if (this.initializedSteps.length === this.steps) {
    //     // this.focusFirstInput();
    //   }
    // },
    stepUpdate() {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(() => {
        // console.log('aaaaaaaaaaaa STEP INDEX debounce', this.dat.index);
        if (!this.initialized) {
          // console.log('aaaaaaaaaaaa STEP INDEX debounce EMIT', this.dat.index);
          window.eventBus.$emit('stepInit', { step: this.dat.index });
          this.initialized = true;
        }
      }, 500);
    },
    focusFirstInput() {
      this.preventBlur = true;
      // if (this.currentStep === 1) {
      // console.log('FOCUS -------', this.dat.index);
      // Find first input field and focus it
      const input = document.getElementById(`assistant-step-${this.dat.index}`).querySelector('input.empty, .ql-editor.ql-blank');
      if (input) input.focus();
      else this.focusDummy();
      setTimeout(() => {
        this.preventBlur = false;
      }, 1000);
    },
    focusDummy() {
      const input = document.getElementById(`dummyInput-${this.dat.index}`);
      if (input) input.focus();
    },
    initDefault(v) {
      this.formValue = v;
    },
  },
};
</script>

<style scoped>
h1 {
  color: #42b983;
}
</style>
